import i18n, { fromSyntax } from "../../i18n";
import { isAlive, MathUtil } from "..";
import GraphConstant from "../../constants/graph";
import { MAX_RETURNING_TIME } from "../../constants/limit";

export const GraphDataMaker = {
	strToLabel(str){
		if(isAlive(str)){
			if(str.toLowerCase() === "null"){
				return i18n.t("unassign");
			}
			return str.charAt(0).toUpperCase() + str.slice(1);
		}
		return i18n.t("unassign");
	},
	makeRenderDataOfObject(objectData, getLabel, getValue, removeZeroValue = true, configs){
		const { 
			itemKey = "item",
			countKey = "count",
			percentKey = "percent",
		} = configs || {};
		const keys = Object.keys(objectData);
		if(keys.length === 0)
			return [];
		let sum = 0;
		let outs = keys.map((k,i)=>{
			const count = getValue(k, objectData[k],i);
			sum += count;
			return {
				[itemKey]: this.toLabel(getLabel(k, objectData[k],i)),
				[countKey]:count, 
				[percentKey]: 0 
			};}
		);
		outs = outs.map((element)=>({
			...element, 
			[percentKey]: (100*element.count/Math.max(1,sum)).toFixed(1)
		}));
		if(removeZeroValue){
			return outs.filter(e=>e.count>0);
		}
		return outs;
	},
	makeRenderDataOfArray(array, getLabel, getValue, removeZeroValue = true, configs){
		const { 
			itemKey = "item",
			countKey = "count",
			percentKey = "percent"
		} = configs || {};
		if(array.length === 0){
			return [];
		}
		let sum = 0;
		let outs = array.map((e,i)=>{
			const count = getValue(e,i);
			sum += count;
			return {
				[itemKey]: this.toLabel(getLabel(e,i)),
				[countKey]:count, 
				[percentKey]: 0 
			};
		});
		outs = outs.map((element)=>({
			...element, 
			[percentKey]: (100*element.count/sum).toFixed(1)
		}));
		if(removeZeroValue){
			return outs.filter(e=>e.count>0);
		}
		return outs;
	},
	translateTargets(sourceArray, getTranslateKey, outputKeys){
		const out = sourceArray.slice(0);
		return out.map((v)=>{
			const outTarget = {...v};
			const translate = i18n.t(getTranslateKey(v));
			outputKeys.forEach(k=>{
				outTarget[k] = translate;
			});
			return outTarget;
		});
	},
	toLabel(value){
		return isAlive(value) ? value : i18n.t("unassign");
	},
	/**
     * Get returning label of returning time
     * ** Note that max possible output is 5
     * @param {string} target 
     */
	returningTimeLabel(target){
		return this.getReturningTimeLabel(this.returningTimeOf(target));
	},
	getReturningTimeLabel(time){
		const timeFormat = i18n.t("returning_time_format");
		const moreTimeFormat = i18n.t("returning_more_time_format");
		const number = Math.min(MAX_RETURNING_TIME, time, 10);
		if(number < MAX_RETURNING_TIME){
			return fromSyntax(timeFormat, {time:`${number}`});
		}
		return fromSyntax(moreTimeFormat, {time:`${number}`});
	},
	returningTimeOf(target){
		return parseInt(target.replace("time","").replace("+",""),10);
	},
	createReturningObject(data, allowZero = false){
		if(data===undefined){
			return data;
		}
		const mutateObject = {};
		if(!allowZero){
			for(let i=1;i<=MAX_RETURNING_TIME;i++){
				mutateObject[this.getReturningTimeLabel(i)] = 0;
			}
		}
		const keys = Object.keys(data);
		keys.forEach(key=>{
			const label = this.returningTimeLabel(key);
			mutateObject[label] = (mutateObject[label] || 0) + data[key];
		});
		return mutateObject;
	},
	/**
     * Create stress level array with description of it.
     * @param {array} levelArray 
     */
	createStressLevelArray(levelArray){
		const sum = Math.max(1,MathUtil.sum(levelArray));
		return Array.from(levelArray, (d, index)=>{
			const risk = GraphConstant.RISK[index];
			return {
				level: index,
				item: this.stressLevelToLabel(index, false),
				short: this.stressLevelToLabel(index, true),
				color: risk.color,
				count: d,
				percent: (100*d / sum).toFixed(2)
			};
		});
	},
	stressLevelToLabel(levelIndex, isShort){
		const risk = GraphConstant.RISK[levelIndex];
		if(isShort){
			return fromSyntax(i18n.t("level_format"), {level:levelIndex+1});
		}
		return fromSyntax(i18n.t("stress_level_format"), {level:levelIndex+1, detail: risk.description});
	}
};


// WEBPACK FOOTER //
// ./src/util/helper/graph.js